__turbopack_context__.v({
  "table": "TaxUnitMobileDetails-module-scss-module__L_xBXa__table",
});
